import { request } from "@/plugins/request";

export const X_ROLE_ORG_ADMIN = "organization-admin";

const baseURL = "/venue-api";

export const platformsService = {
  async getPlatforms({ orgId, params = {} }) {
    return request({
      url: `/venue`,
      baseURL,
      headers: {
        "X-Role": X_ROLE_ORG_ADMIN,
        "X-Organization-ID": orgId,
      },
      params,
      method: "get",
    });
  },

  async getPlatformById(platformId) {
    return request({
      url: `/venue/${platformId}`,
      baseURL,
      method: "get",
    });
  },
  async createPlatform({ orgId, payload }) {
    return request({
      url: `/venue`,
      baseURL,
      headers: {
        "X-Role": X_ROLE_ORG_ADMIN,
        "X-Organization-ID": orgId,
      },
      data: payload,
      method: "post",
    });
  },
  async uploadFile({ orgId, data }) {
    return request({
      url: `/fileupload`,
      headers: {
        "X-Role": X_ROLE_ORG_ADMIN,
        "X-Organization-ID": orgId,
      },
      baseURL,
      data,
      method: "POST",
    });
  },
};
